// Shared "Who gets what" split preview for chauffeur / tour bookings.
// Display-only: mirrors the settlement math used elsewhere (no formula changes).
export default function WhoGetsWhat({ form, vehicles }) {
  const num = (n) => Number(n || 0);
  const v = vehicles.find((x) => x.id === form.vehicle_id);
  const total = num(form.total);
  const fmt = (n) => `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const isThird = v && v.ownership === "third_party";
  let ownerGets = 0, youKeep = 0, note = "", ownerName = (v && v.owner_name) || "Owner";
  if (!isThird) {
    youKeep = total - (num(form.driver_cost) + num(form.gas_cost) + num(form.other_costs));
    note = "Company-owned — you keep the net after costs.";
  } else if ((v.owner_split_type || "percent") === "base_rate") {
    ownerGets = num(form.owner_base_rate);
    youKeep = total - ownerGets;
    note = "Base-rate car — owner takes the base and covers driver + gas.";
  } else {
    const drove = !!form.owner_drove;
    const net = total - (num(form.driver_cost) + num(form.gas_cost) + num(form.other_costs));
    const base = (v.owner_split_type || "percent") === "percent_total" ? total : net;
    const pctShare = base * (num(v.owner_split_percent) / 100);
    ownerGets = pctShare + (drove ? num(form.driver_cost) : 0);
    youKeep = net - pctShare;
    note = `${num(v.owner_split_percent)}% split of ${(v.owner_split_type || "percent") === "percent_total" ? "total (gross)" : "net profit"}${drove ? " · owner drove, so their driver cost is included" : ""}.`;
  }
  const held = (form.balance_held_by || "company") === "driver";
  const dir = isThird ? (held ? `${ownerName} holds the money → they owe you ${fmt(youKeep)}` : `You hold the money → you owe ${ownerName} ${fmt(ownerGets)}`) : "";
  return (
    <div className="border border-primary/30 bg-primary/[0.04] rounded-2xl p-5" data-testid="who-gets-what">
      <div className="label-mono mb-3">Who gets what</div>
      <div className="grid grid-cols-2 gap-4">
        {isThird && (
          <div>
            <div className="text-xs text-muted-foreground">{ownerName} gets</div>
            <div className="font-heading text-2xl tnum text-amber-400 mt-1" data-testid="wgw-owner">{fmt(ownerGets)}</div>
          </div>
        )}
        <div>
          <div className="text-xs text-muted-foreground">You keep</div>
          <div className="font-heading text-2xl tnum text-emerald-400 mt-1" data-testid="wgw-company">{fmt(youKeep)}</div>
        </div>
      </div>
      <div className="text-xs text-muted-foreground mt-3">{note}{dir ? ` · ${dir}` : ""}</div>
    </div>
  );
}
